import {hasCookieConsentMarketing, renewCookieConsent} from "./Utils/Utils.js";

import IntersectionObserverAnimations from './Components/IntersectionObserverAnimations';
import ScrollHandler from "./Components/ScrollHandler.js";

import Menu1 from "./Components/Menu1.js";
import LanguageSwitcher from "./Components/LanguageSwitcher.js";
import MenuOverlayToggler from "./Components/MenuOverlayToggler.js";
import MenuOverlay from "./Components/MenuOverlay.js";

import WPFormsSetup from "./Components/WPFormsSetup.js";

import WPBlockCoverVideo from "./Components/WPBlockCoverVideo.js";
import WPBlockCoverScrollDownBtn from "./Components/WPBlockCoverScrollDownBtn.js";
import WPBlockMediaTextVideo from "./Components/WPBlockMediaTextVideo.js";
import WPBlockVideo from "./Components/WPBlockVideo.js";
import WPBlockVimeoEmbed from "./Components/WPBlockVimeoEmbed.js";
import WPBlockYouTubeEmbed from "./Components/WPBlockYouTubeEmbed.js";
import WPCoreGallery from "./Components/WPCoreGallery.js";
import WPCoreGalleryOverlay from "./Components/WPCoreGalleryOverlay.js";

import ACFBlockAnchorLinks from "./Components/ACFBlockAnchorLinks.js";
import ACFBlockBookRoomParameterBooking from "./Components/ACFBlockBookRoomParameterBooking.js";

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Enable event listener for pushState
const _wr = (type) => {
	const orig = history[type];
	return function() {
		const rv = orig.apply(this, arguments);
		const e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');

//
// Manage IntersectionObservers
const intersectionObserverIsSupported = (!!window.IntersectionObserver || 'IntersectionObserver' in window);
if(intersectionObserverIsSupported) {
	document.body.classList.add('js-intersection-observer');
	new IntersectionObserverAnimations();
}

//
// Blocks
document.querySelectorAll('.wp-block-cover-wrapper.has-video').forEach(block => new WPBlockCoverVideo(block));
document.querySelectorAll('.wp-block-cover-wrapper.is-style-large-scroll-btn').forEach(block => new WPBlockCoverScrollDownBtn(block));
document.querySelectorAll('.wp-block-media-text-wrapper.has-video').forEach(block => new WPBlockMediaTextVideo(block));
document.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new WPBlockVimeoEmbed(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(block => new WPBlockYouTubeEmbed(block));
document.querySelectorAll('.wp-block-gallery-wrapper:has(.wp-block-image a)').forEach(block => new WPCoreGalleryOverlay(block));
document.querySelectorAll('.wp-block-gallery-wrapper.is-style-slideshow').forEach(block => new WPCoreGallery(block));
document.querySelectorAll('.wp-block-video-wrapper:not(.has-autoplay)').forEach(domEl => new WPBlockVideo(domEl));

document.querySelectorAll('.wp-block-acf-anchor-links').forEach(domEl => new ACFBlockAnchorLinks(domEl));
document.querySelectorAll('.wp-block-acf-book-room-parameter-booking').forEach(domEl => new ACFBlockBookRoomParameterBooking(domEl));

//
// Forms
new WPFormsSetup();

//
// Menus
new Menu1();
new MenuOverlay();
new LanguageSwitcher();
new MenuOverlayToggler();

//
// Manage Scroll
new ScrollHandler();

//
// Cookie Compliance
document.querySelectorAll('.cookie-compliance-renew').forEach(btn => btn.addEventListener('click', renewCookieConsent));
window.addEventListener('CookiebotOnAccept',  (e) => {
	if(hasCookieConsentMarketing()) {
		document.querySelectorAll('.cookie-compliance-video').forEach(el => el.classList.remove('js-revealed'));
	}
}, false);